import { render, staticRenderFns } from "./MetadadosCampoDinamicoNumerico.vue?vue&type=template&id=56c10616&"
import script from "./MetadadosCampoDinamicoNumerico.vue?vue&type=script&lang=js&"
export * from "./MetadadosCampoDinamicoNumerico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/shared-components/metadados/campos-dinamicos/MetadadosCampoDinamicoNumerico.vue
// module id = 1345
// module chunks = 28